import { Transition } from '@uirouter/core';
import { AccessibilityStateRegistryService } from '@client/app/pages/accessibility/services/accessibility-state-registry.service';

export const resetAccessibilityStateRegistryForCustomerContext = (transition: Transition): void => {
    const accessibilityStateRegistryService: AccessibilityStateRegistryService = transition.injector().get(AccessibilityStateRegistryService);
    accessibilityStateRegistryService.resetAccessibilityStatesForCustomerSwitch();
};
